export default __webpack_public_path__ + "static/char-48-anr-6d6e10eabc22355ff999737c2c29a623.webp";